import React, { useState, lazy } from 'react';
import { PriceDisplay } from './TopSectionsLP3';
import { trackEvent } from '../utils/pixel';
/* ─── WHAT YOU GET STACK ─── */
export function WhatYouGetSection() {
  return <section className="bg-[#FEFCF8] py-10 px-5 sm:py-14 sm:px-6" data-id="element-359">
      <div className="max-w-[640px] mx-auto" style={{
      fontFamily: "'Nunito', sans-serif"
    }} data-id="element-360">
        <p className="text-[#5E8D5A] text-[11px] font-black tracking-widest uppercase text-center mb-2" data-id="element-361">
          📦 LO QUE RECIBÍS HOY
        </p>
        <h2 className="text-[#1a1a2e] text-[24px] sm:text-[30px] font-[900] text-center mb-10 leading-tight tracking-tight" style={{
        fontFamily: "'Merriweather', serif"
      }} data-id="element-362">
          Kit Definitivo Método 3C
        </h2>

        {/* Product image */}
        <img src="https://cdn.magicpatterns.com/uploads/4SHbQyswZxRd8H1cAZGY76/Principal_y_Bonus.png" alt="Kit Método 3C — Guía principal + 5 bonos" className="w-full max-w-[480px] mx-auto rounded-2xl shadow-[0_16px_48px_rgba(0,0,0,0.12)] mb-10 block" loading="lazy" data-id="element-363" />

        {/* Item 1 */}
        <div className="bg-white rounded-2xl p-5 sm:p-6 mb-4 border border-gray-100 shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-364">
          <div className="flex gap-4 items-start" data-id="element-365">
            <div className="bg-[#1a1a2e] text-white w-11 h-11 rounded-xl flex items-center justify-center text-[14px] font-black flex-shrink-0" data-id="element-366">
              01
            </div>
            <div className="flex-1" data-id="element-367">
              <div className="flex items-center justify-between mb-1" data-id="element-368">
                <h4 className="text-[#1a1a2e] text-[17px] sm:text-[18px] font-black" data-id="element-369">
                  Guía Maestra Método 3C
                </h4>
                <span className="text-gray-400 text-[13px] font-bold line-through flex-shrink-0 ml-3" data-id="element-370">
                  $18.000
                </span>
              </div>
              <p className="text-[#555] text-[14px] leading-relaxed" data-id="element-371">
                La biblia para entender por qué tu hijo rechaza la comida y cómo
                usar la psicología 3C para que acepte nutrientes sin notar la
                diferencia.
              </p>
            </div>
          </div>
        </div>

        {/* Item 2 */}
        <div className="bg-white rounded-2xl p-5 sm:p-6 mb-4 border border-gray-100 shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-372">
          <div className="flex gap-4 items-start" data-id="element-373">
            <div className="bg-[#E67E22] text-white w-11 h-11 rounded-xl flex items-center justify-center text-[14px] font-black flex-shrink-0" data-id="element-374">
              02
            </div>
            <div className="flex-1" data-id="element-375">
              <div className="flex items-center justify-between mb-1" data-id="element-376">
                <h4 className="text-[#1a1a2e] text-[17px] sm:text-[18px] font-black" data-id="element-377">
                  250 Recetas de Nutrición Invisible
                </h4>
                <span className="text-gray-400 text-[13px] font-bold line-through flex-shrink-0 ml-3" data-id="element-378">
                  $12.800
                </span>
              </div>
              <p className="text-[#555] text-[14px] leading-relaxed" data-id="element-379">
                Mila Verdes, muffins de superpoderes y platos tradicionales
                adaptados para que el radar de tu hijo no detecte ni un gramo de
                verdura.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
/* ─── BONUS SECTION — LIGHT VALUE STACK WITH PRODUCT BOX CARDS ─── */
export function BonusSectionLP3() {
  return <section className="py-10 px-5 sm:py-14 sm:px-6 bg-[#FEFCF8] relative" data-id="element-380">
      <div className="max-w-[720px] mx-auto relative" style={{
      fontFamily: "'Nunito', sans-serif"
    }} data-id="element-381">
        <div className="text-center mb-8 relative" data-id="element-382">
          <div className="absolute -top-4 right-0 sm:right-10 bg-red-600 text-white text-[10px] sm:text-[12px] font-black px-3 py-1 rounded-full shadow-lg transform rotate-3 z-10" data-id="element-383">
            ⏳ TIEMPO LIMITADO
          </div>
          <p className="text-[#1a1a2e] text-[12px] font-black tracking-widest uppercase mb-2" data-id="element-384">
            🎁 BONOS DE EMERGENCIA INCLUIDOS
          </p>
          <h2 className="text-[#1a1a2e] text-[24px] sm:text-[30px] font-[900] leading-tight tracking-tight" style={{
          fontFamily: "'Merriweather', serif"
        }} data-id="element-385">
            5 Herramientas Extra{' '}
            <span style={{
            color: '#27AE60'
          }} data-id="element-386">
              GRATIS
            </span>
          </h2>
        </div>

        <div className="space-y-6" data-id="element-387">
          {/* Bonus 1 */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-[0_4px_16px_rgba(0,0,0,0.06)]" data-id="element-388">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5" data-id="element-389">
              <div className="w-full sm:w-[200px] flex-shrink-0 relative" data-id="element-390">
                <div className="absolute -top-3 -left-3 bg-[#E67E22] text-white w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black leading-tight text-center shadow-md z-10" data-id="element-391">
                  BONO
                  <br data-id="element-392" />1
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/cCBnbWPnGaJcGN8J1Sri9w/Bono_1.png" alt="Semana Resuelta 7D" className="w-full h-auto object-cover rounded-xl shadow-sm" loading="lazy" data-id="element-393" />
              </div>
              <div className="flex-1 w-full text-center sm:text-left" data-id="element-394">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 mb-2" data-id="element-395">
                  <h4 className="text-[#1a1a2e] text-[18px] sm:text-[20px] font-black" data-id="element-396">
                    Semana Resuelta 7D
                  </h4>
                  <span className="bg-green-100 text-[#27AE60] text-[10px] font-black py-0.5 px-2 rounded-full" data-id="element-397">
                    GRATIS
                  </span>
                </div>
                <p className="text-gray-500 text-[14px] sm:text-[15px] leading-relaxed mb-4" data-id="element-398">
                  Plan de choque inmediato para los primeros 7 días. La{' '}
                  <span className="bg-yellow-100 text-[#1a1a2e] font-black px-1 rounded" data-id="element-399">
                    Hoja de ruta inmediata
                  </span>{' '}
                  para revertir la desnutrición silenciosa de lunes a domingo.
                </p>
                <div className="border-t border-dashed border-gray-200 pt-3" data-id="element-400">
                  <p className="text-[14px] font-black" data-id="element-401">
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-402">
                      VALOR:{' '}
                    </span>
                    <span style={{
                    color: '#DAA520'
                  }} data-id="element-403">
                      $5.800
                    </span>
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-404">
                      {' '}
                      — ¡HOY GRATIS!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-[0_4px_16px_rgba(0,0,0,0.06)]" data-id="element-405">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5" data-id="element-406">
              <div className="w-full sm:w-[200px] flex-shrink-0 relative" data-id="element-407">
                <div className="absolute -top-3 -left-3 bg-[#5E8D5A] text-white w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black leading-tight text-center shadow-md z-10" data-id="element-408">
                  BONO
                  <br data-id="element-409" />2
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/jc15UDexTiE3NdgPiYBdKe/Bono_2.png" alt="Guía Anti-Detectives" className="w-full h-auto object-cover rounded-xl shadow-sm" loading="lazy" data-id="element-410" />
              </div>
              <div className="flex-1 w-full text-center sm:text-left" data-id="element-411">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 mb-2" data-id="element-412">
                  <h4 className="text-[#1a1a2e] text-[18px] sm:text-[20px] font-black" data-id="element-413">
                    Guía Anti-Detectives
                  </h4>
                  <span className="bg-green-100 text-[#27AE60] text-[10px] font-black py-0.5 px-2 rounded-full" data-id="element-414">
                    GRATIS
                  </span>
                </div>
                <p className="text-gray-500 text-[14px] sm:text-[15px] leading-relaxed mb-4" data-id="element-415">
                  Técnicas avanzadas y{' '}
                  <span className="bg-yellow-100 text-[#1a1a2e] font-black px-1 rounded" data-id="element-416">
                    Estrategias de camuflaje
                  </span>{' '}
                  para que el niño más "desconfiado" no encuentre ni rastro del
                  camuflado nutritivo.
                </p>
                <div className="border-t border-dashed border-gray-200 pt-3" data-id="element-417">
                  <p className="text-[14px] font-black" data-id="element-418">
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-419">
                      VALOR:{' '}
                    </span>
                    <span style={{
                    color: '#DAA520'
                  }} data-id="element-420">
                      $4.200
                    </span>
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-421">
                      {' '}
                      — ¡HOY GRATIS!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-[0_4px_16px_rgba(0,0,0,0.06)]" data-id="element-422">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5" data-id="element-423">
              <div className="w-full sm:w-[200px] flex-shrink-0 relative" data-id="element-424">
                <div className="absolute -top-3 -left-3 bg-[#F5C842] text-[#1a1a2e] w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black leading-tight text-center shadow-md z-10" data-id="element-425">
                  BONO
                  <br data-id="element-426" />3
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/3q78ng2yo8wid7YEiz91T4/Bono_3.png" alt="Pack Lunchbox Jardín" className="w-full h-auto object-cover rounded-xl shadow-sm" loading="lazy" data-id="element-427" />
              </div>
              <div className="flex-1 w-full text-center sm:text-left" data-id="element-428">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 mb-2" data-id="element-429">
                  <h4 className="text-[#1a1a2e] text-[18px] sm:text-[20px] font-black" data-id="element-430">
                    Pack Lunchbox Jardín
                  </h4>
                  <span className="bg-green-100 text-[#27AE60] text-[10px] font-black py-0.5 px-2 rounded-full" data-id="element-431">
                    GRATIS
                  </span>
                </div>
                <p className="text-gray-500 text-[14px] sm:text-[15px] leading-relaxed mb-4" data-id="element-432">
                  La solución para que su comida en el jardín sea nutritiva y{' '}
                  <span className="bg-yellow-100 text-[#1a1a2e] font-black px-1 rounded" data-id="element-433">
                    Tupper vacío garantizado
                  </span>
                  , sin que se tiente con las galletitas de otros.
                </p>
                <div className="border-t border-dashed border-gray-200 pt-3" data-id="element-434">
                  <p className="text-[14px] font-black" data-id="element-435">
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-436">
                      VALOR:{' '}
                    </span>
                    <span style={{
                    color: '#DAA520'
                  }} data-id="element-437">
                      $3.500
                    </span>
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-438">
                      {' '}
                      — ¡HOY GRATIS!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bonus 4 */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-[0_4px_16px_rgba(0,0,0,0.06)]" data-id="element-439">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5" data-id="element-440">
              <div className="w-full sm:w-[200px] flex-shrink-0 relative" data-id="element-441">
                <div className="absolute -top-3 -left-3 bg-[#1a1a2e] text-white w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black leading-tight text-center shadow-md z-10" data-id="element-442">
                  BONO
                  <br data-id="element-443" />4
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/c5Lkv9y2d1gre6KUey8AV6/Bono_4.png" alt="Planner Organizador" className="w-full h-auto object-cover rounded-xl shadow-sm" loading="lazy" data-id="element-444" />
              </div>
              <div className="flex-1 w-full text-center sm:text-left" data-id="element-445">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 mb-2" data-id="element-446">
                  <h4 className="text-[#1a1a2e] text-[18px] sm:text-[20px] font-black" data-id="element-447">
                    Planner Organizador 10/20/30
                  </h4>
                  <span className="bg-green-100 text-[#27AE60] text-[10px] font-black py-0.5 px-2 rounded-full" data-id="element-448">
                    GRATIS
                  </span>
                </div>
                <p className="text-gray-500 text-[14px] sm:text-[15px] leading-relaxed mb-4" data-id="element-449">
                  Organización estratégica para madres que no tienen tiempo.{' '}
                  <span className="bg-yellow-100 text-[#1a1a2e] font-black px-1 rounded" data-id="element-450">
                    Ahorro de tiempo real
                  </span>{' '}
                  para que dejes de improvisar y tus hijos dejen la comida
                  procesada.
                </p>
                <div className="border-t border-dashed border-gray-200 pt-3" data-id="element-451">
                  <p className="text-[14px] font-black" data-id="element-452">
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-453">
                      VALOR:{' '}
                    </span>
                    <span style={{
                    color: '#DAA520'
                  }} data-id="element-454">
                      $4.500
                    </span>
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-455">
                      {' '}
                      — ¡HOY GRATIS!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bonus 5 */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-[0_4px_16px_rgba(0,0,0,0.06)]" data-id="element-456">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5" data-id="element-457">
              <div className="w-full sm:w-[200px] flex-shrink-0 relative" data-id="element-458">
                <div className="absolute -top-3 -left-3 bg-[#DC2626] text-white w-10 h-10 rounded-full flex items-center justify-center text-[10px] font-black leading-tight text-center shadow-md z-10" data-id="element-459">
                  BONO
                  <br data-id="element-460" />5
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/eEt9vbCbXXZnc5STj9uJ7y/Bono_5.png" alt="Guía Plato Seguro" className="w-full h-auto object-cover rounded-xl shadow-sm" loading="lazy" data-id="element-461" />
              </div>
              <div className="flex-1 w-full text-center sm:text-left" data-id="element-462">
                <div className="flex flex-col sm:flex-row items-center sm:items-center gap-2 mb-2" data-id="element-463">
                  <h4 className="text-[#1a1a2e] text-[18px] sm:text-[20px] font-black" data-id="element-464">
                    Guía Plato Seguro
                  </h4>
                  <span className="bg-green-100 text-[#27AE60] text-[10px] font-black py-0.5 px-2 rounded-full" data-id="element-465">
                    GRATIS
                  </span>
                </div>
                <p className="text-gray-500 text-[14px] sm:text-[15px] leading-relaxed mb-4" data-id="element-466">
                  Cómo diseñar platos que{' '}
                  <span className="bg-yellow-100 text-[#1a1a2e] font-black px-1 rounded" data-id="element-467">
                    Baja la guardia cerebral
                  </span>{' '}
                  de un nene selectivo, eliminando el rechazo antes del primer
                  bocado.
                </p>
                <div className="border-t border-dashed border-gray-200 pt-3" data-id="element-468">
                  <p className="text-[14px] font-black" data-id="element-469">
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-470">
                      VALOR:{' '}
                    </span>
                    <span style={{
                    color: '#DAA520'
                  }} data-id="element-471">
                      $2.800
                    </span>
                    <span style={{
                    color: '#27AE60'
                  }} data-id="element-472">
                      {' '}
                      — ¡HOY GRATIS!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Price Summary Box — Receipt Style */}
        <div className="mt-10 border-2 border-dashed border-gray-400 bg-gray-50 rounded-xl p-6 sm:p-8 text-center max-w-[500px] mx-auto" data-id="element-473">
          <p className="text-gray-500 text-[14px] font-bold uppercase tracking-wider mb-1" data-id="element-474">
            Valor Total de la Colección:
          </p>
          <p className="text-gray-500 text-[20px] font-black line-through mb-4" data-id="element-475">
            $35.799
          </p>
          <p className="text-[#1a1a2e] text-[14px] font-bold uppercase tracking-wider mb-1" data-id="element-476">
            Precio de Lanzamiento HOY:
          </p>
          <p className="text-[42px] sm:text-[48px] font-black leading-none mb-3" style={{
          color: '#27AE60'
        }} data-id="element-477">
            <PriceDisplay amount={14999} data-id="element-478" />
          </p>
          <div className="inline-block bg-[#27AE60]/10 border border-[#27AE60]/30 text-[#27AE60] text-[13px] font-black py-1.5 px-5 rounded-full" data-id="element-479">
            💚 Ahorrás $20.800 — 58% OFF
          </div>
        </div>
      </div>
    </section>;
}
/* ─── DYNAMIC PRICING OFFER ─── */
export function DynamicPricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 14999;
  const bump1Price = 3990;
  const bump2Price = 2990;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const formatPrice = (price: number) => {
    return '$' + price.toLocaleString('es-AR').replace(',', '.');
  };
  const productNames = ['Kit Método 3C'];
  if (bump1) productNames.push('Jugos Camuflados');
  if (bump2) productNames.push('Tabla Mágica');
  const productCount = 1 + (bump1 ? 1 : 0) + (bump2 ? 1 : 0);
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://vitaliaguides.com/cart/46709797519537:1';
    if (bump1) return 'https://vitaliaguides.com/cart/46709792800945:1';
    if (bump2) return 'https://vitaliaguides.com/cart/46709795684529:1';
    return 'https://vitaliaguides.com/cart/46709792178353:1';
  };
  const handleCheckoutClick = () => {
    trackEvent('AddToCart', {
      content_name: productNames.join(' + '),
      content_type: 'product',
      value: total / 100,
      currency: 'ARS',
      num_items: productCount
    });
  };
  return <section className="py-10 px-5 sm:py-14 sm:px-6" style={{
    background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)'
  }} data-id="element-480">
      <style data-id="element-481">{`
        @keyframes pulse-orange-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(255,107,0,0.4); }
          50% { box-shadow: 0 0 40px rgba(255,107,0,0.7), 0 0 80px rgba(255,107,0,0.25); }
        }
        .pulse-orange-cta { animation: pulse-orange-glow 2.5s ease-in-out infinite; }
      `}</style>

      <div className="max-w-[500px] mx-auto text-center" style={{
      fontFamily: "'Nunito', sans-serif"
    }} data-id="element-482">
        <h2 className="text-white text-[24px] sm:text-[28px] font-[900] mb-3 leading-tight tracking-tight" style={{
        fontFamily: "'Merriweather', serif"
      }} data-id="element-483">
          La salud de tu hijo no puede esperar.
        </h2>
        <p className="text-gray-400 text-[14px] sm:text-[15px] leading-relaxed mb-8 max-w-[420px] mx-auto" data-id="element-484">
          Recibí el Método 3C + los 5 Bonos de Emergencia directamente en tu
          celular.
        </p>

        {/* Product mockup */}
        <img src="https://cdn.magicpatterns.com/uploads/1gJS9qn8hGidHjVXRN92gJ/Principal_y_Bonus.png" alt="Kit Método 3C completo" className="w-full max-w-[380px] mx-auto mb-8 rounded-xl" loading="lazy" data-id="element-485" />

        {/* Pricing */}
        <div className="mb-6" data-id="element-486">
          <p className="text-gray-500 text-[14px] font-bold uppercase tracking-wider mb-1" data-id="element-487">
            Precio Normal
          </p>
          <p className="text-white/40 text-[22px] font-black line-through mb-2" data-id="element-488">
            $35.799
          </p>
          <p className="text-gray-500 text-[14px] font-bold uppercase tracking-wider mb-1" data-id="element-489">
            Precio con Descuento HOY
          </p>
          <p className="text-[#F5C842] text-[48px] sm:text-[56px] font-black leading-none" data-id="element-490">
            <PriceDisplay amount={14999} data-id="element-491" />
          </p>
          <div className="mt-3 inline-block bg-[#5E8D5A]/20 text-[#5E8D5A] border border-[#5E8D5A]/30 text-[13px] font-black py-1.5 px-5 rounded-full" data-id="element-492">
            💚 Ahorrás $20.800 — 58% OFF
          </div>
        </div>

        {/* CTA */}
        <div className="relative mb-8" data-id="element-493"></div>

        {/* Order Bumps — Dark Theme */}
        <div className="flex flex-col gap-3 mb-8 text-left" data-id="element-494">
          {/* Bump 1 */}
          <div className={`rounded-2xl p-3 sm:p-4 border-2 transition-all duration-200 flex items-center gap-3 sm:gap-4 ${bump1 ? 'border-[#5E8D5A] bg-[#5E8D5A]/10' : 'border-[#E67E22]/30 bg-white/5'}`} data-id="element-495">
            <img src="https://cdn.magicpatterns.com/uploads/5ikgyziXYvZ1ZbuASTqmxf/Order_1.png" alt="Jugos Camuflados" className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-496" />
            <div className="flex-1 min-w-0" data-id="element-497">
              <h3 className="text-white text-[14px] sm:text-[15px] font-black leading-tight mb-1" data-id="element-498">
                SÍ, SUMAR JUGOS CAMUFLADOS
              </h3>
              <p className="text-gray-400 text-[12px] sm:text-[13px] leading-snug mb-1.5" data-id="element-499">
                Todas sus vitaminas en un solo vaso, sin que se dé cuenta.
              </p>
              <p className="text-[#5E8D5A] text-[13px] sm:text-[14px] font-black mb-2" data-id="element-500">
                + $3.990{' '}
                <span className="text-[#F5C842] text-[11px] font-bold" data-id="element-501">
                  (Ahorrá 70% hoy)
                </span>
              </p>
              <button onClick={() => setBump1(!bump1)} className={`text-[11px] sm:text-[12px] font-black uppercase tracking-wider py-1.5 px-3 rounded-lg w-full transition-colors ${bump1 ? 'bg-[#5E8D5A]/20 text-[#5E8D5A]' : 'bg-[#E67E22]/15 text-[#E67E22] hover:bg-[#E67E22]/25'}`} data-id="element-502">
                {bump1 ? '✓ AGREGADO' : 'SUMAR AHORA'}
              </button>
            </div>
          </div>

          {/* Bump 2 */}
          <div className={`rounded-2xl p-3 sm:p-4 border-2 transition-all duration-200 flex items-center gap-3 sm:gap-4 ${bump2 ? 'border-[#5E8D5A] bg-[#5E8D5A]/10' : 'border-white/10 bg-white/5'}`} data-id="element-503">
            <img src="https://cdn.magicpatterns.com/uploads/5S8q3Am1n5fvFMmzJUBx2H/Order_2.png" alt="Tabla Mágica" className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-504" />
            <div className="flex-1 min-w-0" data-id="element-505">
              <h3 className="text-white text-[14px] sm:text-[15px] font-black leading-tight mb-1" data-id="element-506">
                SÍ, SUMAR TABLA MÁGICA
              </h3>
              <p className="text-gray-400 text-[12px] sm:text-[13px] leading-snug mb-1.5" data-id="element-507">
                El juego que reduce la ansiedad y lo anima a probar texturas
                nuevas.
              </p>
              <p className="text-[#5E8D5A] text-[13px] sm:text-[14px] font-black mb-2" data-id="element-508">
                + $2.990{' '}
                <span className="text-[#F5C842] text-[11px] font-bold" data-id="element-509">
                  (Única oportunidad)
                </span>
              </p>
              <button onClick={() => setBump2(!bump2)} className={`text-[11px] sm:text-[12px] font-black uppercase tracking-wider py-1.5 px-3 rounded-lg w-full transition-colors ${bump2 ? 'bg-[#5E8D5A]/20 text-[#5E8D5A]' : 'bg-white/10 text-gray-300 hover:bg-white/15'}`} data-id="element-510">
                {bump2 ? '✓ AGREGADO' : 'SUMAR AHORA'}
              </button>
            </div>
          </div>
        </div>

        {/* Dynamic Total — Dark */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-5 mb-4 backdrop-blur-sm" data-id="element-511">
          <div className="flex justify-between items-end" data-id="element-512">
            <div className="text-left" data-id="element-513">
              <p className="text-gray-500 text-[12px] font-bold uppercase tracking-wider mb-1" data-id="element-514">
                TOTAL A PAGAR
              </p>
              <p className="text-gray-300 text-[13px] font-semibold" data-id="element-515">
                {productCount} {productCount === 1 ? 'producto' : 'productos'}
              </p>
            </div>
            <div className="text-[#F5C842] text-[32px] font-black leading-none" data-id="element-516">
              {formatPrice(total)}
            </div>
          </div>
        </div>

        {/* CTA — Paz en mi mesa */}
        <a href={getCheckoutUrl()} onClick={handleCheckoutClick} className="pulse-orange-cta text-white font-black py-5 px-8 rounded-2xl block w-full transition-all duration-200 text-[17px] sm:text-[19px] text-center no-underline mb-4" style={{
        background: '#FF6B00'
      }} data-id="element-517">
          SÍ, QUIERO EL MÉTODO 3C — ACCESO INMEDIATO
        </a>

        {/* Trust elements */}
        <img src="https://cdn.magicpatterns.com/uploads/w5y4NrCNFhtKGREXWxX61b/metodos_de_pago.png" alt="Métodos de pago: Mercado Pago, Visa, MasterCard" className="mx-auto w-full max-w-[240px] object-contain opacity-60 mb-2" loading="lazy" data-id="element-518" />
        <p className="text-gray-400 text-[11px] mb-5" data-id="element-519">
          Acceso seguro y encriptado. Recibís el material en tu email al
          instante.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-gray-500 text-[12px] font-semibold mb-5" data-id="element-520">
          <span data-id="element-521">🔒 Pago 100% seguro</span>
          <span data-id="element-522">📥 Acceso inmediato</span>
          <span data-id="element-523">💳 Todas las tarjetas</span>
        </div>

        {/* Guarantee */}
        <div className="mt-8 bg-white/5 border border-white/10 rounded-2xl p-5 text-center backdrop-blur-sm" data-id="element-524">
          <div className="text-3xl mb-2" data-id="element-525">🛡️</div>
          <h3 className="text-white text-[16px] font-black mb-2" data-id="element-526">
            GARANTÍA DE 7 DÍAS
          </h3>
          <p className="text-gray-400 text-[13px] leading-relaxed max-w-[400px] mx-auto" data-id="element-527">
            Si en una semana no lográs que tu hijo pruebe un bocado nuevo usando
            nuestra técnica, te devolvemos el 100%. Sin preguntas. El riesgo es
            nuestro, la salud es de tu hijo.
          </p>
        </div>
      </div>
    </section>;
}
/* ─── SOCIAL PROOF / TESTIMONIAL (Masonry-style) ─── */
export function TestimonialMasonrySection() {
  return <section className="bg-[#FEFCF8] py-10 px-5 sm:py-12 sm:px-6" data-id="element-528">
      <div className="max-w-[720px] mx-auto" data-id="element-529">
        <p className="text-[#5E8D5A] text-[11px] font-black tracking-widest uppercase text-center mb-2" data-id="element-530">
          💬 TESTIMONIOS VERIFICADOS
        </p>
        <h2 className="text-[#1a1a2e] text-[22px] sm:text-[26px] font-[900] text-center mb-8 leading-tight tracking-tight" style={{
        fontFamily: "'Merriweather', serif"
      }} data-id="element-531">
          Lo que dicen quienes ya usaron el método
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-532">
          {/* Testimonial 1 — Featured */}
          <div className="md:col-span-2 bg-white rounded-2xl p-6 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-533">
            <div className="flex items-start gap-4" data-id="element-534">
              <div className="w-12 h-12 rounded-full bg-[#5E8D5A]/10 flex items-center justify-center text-xl flex-shrink-0" data-id="element-535">
                👩
              </div>
              <div className="flex-1" data-id="element-536">
                <div className="flex items-center gap-2 mb-2" data-id="element-537">
                  <span className="text-yellow-400 text-sm" data-id="element-538">⭐⭐⭐⭐⭐</span>
                  <span className="text-gray-400 text-[11px] font-bold" data-id="element-539">
                    Compra verificada
                  </span>
                </div>
                <p className="text-[#1a1a2e] text-[15px] leading-relaxed font-medium mb-3" data-id="element-540">
                  "Pasé de llorar en cada cena a ver el plato vacío. Recobró el
                  color en la cara y ya no se cansa en el jardín."
                </p>
                <p className="text-gray-500 text-[13px] font-bold" data-id="element-541">
                  — Mariana R., Mendoza
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-542">
            <div className="flex items-center gap-2 mb-2" data-id="element-543">
              <span className="text-yellow-400 text-sm" data-id="element-544">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-[#1a1a2e] text-[14px] leading-relaxed font-medium mb-2" data-id="element-545">
              "En 3 días mi hijo comió brócoli sin darse cuenta. Lloré de la
              emoción."
            </p>
            <p className="text-gray-500 text-[12px] font-bold" data-id="element-546">
              — Carla M., CABA
            </p>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-547">
            <div className="flex items-center gap-2 mb-2" data-id="element-548">
              <span className="text-yellow-400 text-sm" data-id="element-549">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-[#1a1a2e] text-[14px] leading-relaxed font-medium mb-2" data-id="element-550">
              "Las milanesas verdes fueron un éxito total. Primera noche que no
              cocino doble."
            </p>
            <p className="text-gray-500 text-[12px] font-bold" data-id="element-551">
              — Florencia S., Córdoba
            </p>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-552">
            <div className="flex items-center gap-2 mb-2" data-id="element-553">
              <span className="text-yellow-400 text-sm" data-id="element-554">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-[#1a1a2e] text-[14px] leading-relaxed font-medium mb-2" data-id="element-555">
              "El bono Anti-Detectives es oro puro. Mi nene no detectó nada."
            </p>
            <p className="text-gray-500 text-[12px] font-bold" data-id="element-556">
              — Valentina P., Rosario
            </p>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-557">
            <div className="flex items-center gap-2 mb-2" data-id="element-558">
              <span className="text-yellow-400 text-sm" data-id="element-559">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-[#1a1a2e] text-[14px] leading-relaxed font-medium mb-2" data-id="element-560">
              "La vianda del jardín vuelve vacía por primera vez. No lo puedo
              creer."
            </p>
            <p className="text-gray-500 text-[12px] font-bold" data-id="element-561">
              — Lucía G., Tucumán
            </p>
          </div>
        </div>

        {/* WhatsApp screenshot testimonials */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-562">
          <div className="rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.10)] bg-white" data-id="element-563">
            <img src="https://cdn.magicpatterns.com/uploads/qBeAp9Q3ep6rcdWe4PDvhx/CARLA.png" alt="Testimonio de Carla por WhatsApp" className="w-full h-auto object-contain" loading="lazy" data-id="element-564" />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.10)] bg-white" data-id="element-565">
            <img src="https://cdn.magicpatterns.com/uploads/myhcDtZLL5dvmdkTEDDccQ/FLORENCIA.png" alt="Testimonio de Florencia por WhatsApp" className="w-full h-auto object-contain" loading="lazy" data-id="element-566" />
          </div>
          <div className="rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.10)] bg-white" data-id="element-567">
            <img src="https://cdn.magicpatterns.com/uploads/1J1DozQ5HATUFBJWhFPbug/VALENTINA.png" alt="Testimonio de Valentina por WhatsApp" className="w-full h-auto object-contain" loading="lazy" data-id="element-568" />
          </div>
        </div>
      </div>
    </section>;
}